<template>
  <div :class="$style.container">

    <Loading :loading="loading">
      <Item title=" ">
        <el-radio v-model="rule" :label="0">单个转入</el-radio>
        <el-radio v-model="rule" :label="1">批量转入</el-radio>
      </Item>

      <template v-if="rule === 0">
        <Item title="转入的域名" required>
          <el-input v-model="domainName" placeholder="请填写" />
        </Item>

        <Item title="转移码" required>
          <el-input v-model="code" placeholder="请填写"></el-input>
        </Item>
      </template>

      <Item v-else title="转入的域名" :class="$style.input_item">
        <template v-slot:nameDesc>
          <p :class="$style.input_item_tip">(格式：域名,转移码)</p>
        </template>

        <div :class="$style.textarea_wrap">
          <el-input
            v-model="text"
            type="textarea"
            placeholder="每行一个域名，最多一次性转入500个，单行域名格式为：域名,转移码，例如：baidu.com,1234567"
            :autosize="{ minRows: 10, maxRows: 10 }"
            @keyup.32.native="onKeyupSpace"
          >
          </el-input>
          <div :class="$style.textarea_count">
            {{ `${getDomainNames().length}/500` }}
          </div>
        </div>
      </Item>

      <Item title="DNS设置">
        <el-radio v-model="dnsType" :label="0">原DNS</el-radio>
        <el-radio v-model="dnsType" :label="1">我司DNS</el-radio>
      </Item>

      <Item title=" ">
        <Button type="primary" @click="submit">提交转入</Button>
      </Item>

      <Item title=" ">
        <el-checkbox v-model="agree">我已阅读并同意</el-checkbox>
        <AgreementPopup :title="agreeTitle" :content="agreeContent" />
      </Item>
    </Loading>

    <EnterTips />

    <template v-if="resultVisible">
      <EnterResultPopup :list="resultList" @close="setResultVisible(false)" />
    </template>
  </div>
</template>

<script>
import EnterTips from "./EnterTips.vue";
import EnterResultPopup from "./EnterResultPopup.vue";
import AgreementPopup from "@components/AgreementPopup.vue";

import { saveTransferInto } from "@server";
import transferRules from "@constant/transferRules.js";

export default {
  name: "EnterSubmit",
  components: { EnterTips, EnterResultPopup, AgreementPopup },
  data() {
    return {
      loading: false,

      rule: 0,
      text: "",
      domainName: "",
      code: "",
      dnsType: 0,
      agree: false,
      agreeTitle: transferRules.title,
      agreeContent: transferRules.content,

      // 转入结果
      resultList: [],
      resultVisible: false,
    };
  },
  methods: {
    setVisible(visible) {
      this.visible = visible;
    },

    onKeyupSpace() {
      this.text = this.text.trim();
    },

    getDomainNames() {
      let textArr = this.text
        .split("\n")
        .filter((i) => !!i)
        .map((i) => i.replace(/\s+/g, ""));
      textArr = [...new Set(textArr)];
      return textArr;
    },

    checkSubmit() {
      if (this.rule === 0) {
        if (!this.domainName) {
          this.$message({ message: "请输入要转入的域名!", type: "warning" });
          return false;
        }
        if (!this.code) {
          this.$message({ message: "请输入转移码!", type: "warning" });
          return false;
        }
      } else {
        if (!this.text) {
          this.$message({ message: "请至少输入一个域名!", type: "warning" });
          return false;
        }
      }

      if (!this.agree) {
        this.$message({
          message: `请阅读并同意${this.agreeTitle}!`,
          type: "warning",
        });
        return false;
      }

      return true;
    },

    async submit() {
      if (!this.checkSubmit()) return;

      this.loading = true;
      let data = { type: this.dnsType };
      if (this.rule === 0) {
        data.info = [`${this.domainName},${this.code}`];
      } else {
        const textArr = this.getDomainNames();
        this.text = textArr.join("\n");
        data.info = textArr;
      }
      const res = await saveTransferInto(data);

      if (res.code === 200) {
        if (res.data.length > 0) {
          this.resultList = res.data;
          this.setResultVisible(true);
        } else {
          this.$message({ message: "加入购物成功!", type: "success" });
          setTimeout(() => {
            window.location.href = "/cart";
          }, 500);
        }
      }

      this.loading = false;
    },

    setResultVisible(v) {
      this.resultVisible = v;
    },
  },
};
</script>

<style lang="scss" module scoped>
.container {
  min-height: 300px;
  font-size: rem(14);
  color: #333;

  :global {
    ::v-deep .gl-item {
      margin-bottom: 30px;

      .gl-item__left {
        width: 160px;
        margin-right: 30px;
        justify-content: flex-end;
      }
    }

    .el-input {
      width: rem(360);
    }

    ::v-deep .el-textarea {
      width: 500px !important;
      .el-textarea__inner {
        padding: 20px;
      }
    }
  }

  .top {
    padding: 20px 30px;
    margin-bottom: rem(50);
    background-color: #f4f4f7;
  }

  .input_item {
    :global {
      ::v-deep .gl-item__left {
        align-self: flex-start;
        transform: translateY(20px);

        flex-direction: column;
        align-items: flex-end;
      }
    }

    .input_item_tip {
      color: $theme-color;
      line-height: 28px;
    }
  }

  .textarea_wrap {
    position: relative;
    .textarea_count {
      position: absolute;
      right: 20px;
      bottom: 20px;
      font-size: 14px;
      color: #898989;
    }
  }
}
</style>
